module.exports = __webpack_public_path__ + "static/media/light-rain.07280979.svg";